import { Image as ImageIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { isString, useField } from 'formik';
import React, { useCallback, useState } from 'react';
import * as Yup from 'yup';

import { FormikTextField, UploadQRDialog } from 'components';
import { FormFieldProps, GetFieldValidatorFn } from 'types';

import { getTCommon, useTFeature } from '../fields.utils';

export const Field: React.FC<FormFieldProps> = ({
  name,
  required = false,
  disabled = false,
}) => {
  const { t } = useTFeature();
  const [open, setOpen] = useState(false);

  const [, , helpers] = useField(name);

  const handleClose = useCallback(
    (value?: string) => {
      if (isString(value)) {
        helpers.setValue(value);
      }
      setOpen(false);
    },
    [helpers],
  );

  return (
    <div className="tw-flex tw-items-center">
      <FormikTextField
        name={name}
        label={t('fields.payment_link.label')}
        fullWidth
        required={required}
        disabled={disabled}
      />
      <IconButton
        sx={{ ml: 1 }}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        <ImageIcon />
      </IconButton>
      <UploadQRDialog open={open} onClose={handleClose} />
    </div>
  );
};

export const getValidator: GetFieldValidatorFn = ({ required }) => {
  const tCommon = getTCommon();

  const schema = Yup.string()
    .url(tCommon('errors.invalid'))
    .matches(/^https:\/\//, tCommon('errors.invalid'));

  if (!required) {
    return schema.nullable();
  }

  return schema.required(tCommon('errors.required'));
};
